/* eslint-disable react/destructuring-assignment */
import { useState, useEffect } from "react";
import Hl7Standard from "hl7-standard";
import useFetch from "use-http";
import config from "../../config";
import SubNav from "../components/Workflows/Builder/Elements/SubNav";
import WorkflowsGrid from "../components/Workflows/WorkflowsGrid";
import ELayerMain from "../components/Workflows/Builder/ELayer";
import TLayerMain from "../components/Workflows/Builder/TLayer";
import LLayerMain from "../components/Workflows/Builder/LLayer";
import AdaptersMain from "../components/Workflows/Builder/Adapters";
import TargetValueModal from "../components/Workflows/Builder/Elements/TargetValueModal";
import ConfirmModal from "../components/Base/Elements/Confirmations/ConfirmModal";
import TemplatesModal from "../components/Workflows/Builder/Elements/TemplatesModal";

import uuid from "react-uuid";
import {
  transformPayload,
  flattenSampleDataNoAmpersand,
  flattenSampleData,
  buildPayload,
  createFHIRBundle
} from "../services/parsing";
import logo from "../../images/retrohook.png";

const hl7v2EventTofhirr4MethodMap = [
  { "id": 1, "hl7v2": "A01", "label": "A01 -> Create", "method": "CREATE" },
  { "id": 2, "hl7v2": "A08", "label": "A08 -> Update", "method": "UPDATE" },
  { "id": 3, "hl7v2": "A02", "label": "A02 -> Update", "method": "UPDATE" },
  { "id": 4, "hl7v2": "A04", "label": "A04 -> Create", "method": "CREATE" },
  { "id": 5, "hl7v2": "A05", "label": "A05 -> Create", "method": "CREATE" },
  { "id": 6, "hl7v2": "A11", "label": "A11 -> Update", "method": "UPDATE" },
  { "id": 7, "hl7v2": "A12", "label": "A12 -> Update", "method": "UPDATE" },
  { "id": 8, "hl7v2": "A13", "label": "A13 -> Update", "method": "UPDATE" },
  { "id": 9, "hl7v2": "A31", "label": "A31 -> Update", "method": "UPDATE" },
  { "id": 10, "hl7v2": "A40", "label": "A40 -> Update", "method": "UPDATE" },
  { "id": 11, "hl7v2": "A03", "label": "A03 -> Update", "method": "UPDATE" }
];

export default function Workflows(props: any) {
  const { post, response, loading } = useFetch(config.url);
  const placeholder = {
    SK: "",
    PK: "",
    flowName: "",
    icon: "",
    sampleMessage: '',
    trigger: { type: "MLLP", formula: "", key: "", custom: {}, host: '', port: 22, username: '', password: '', path: '' },
    next: { type: "HTTPS JSON", url: "", ip: "", port: "", action: "", key: "", bucket: "", method: ''},
    fields: {},
    lookups: [],
    events: [],
    environment: props.selectedEnvironment,
    workspace: props.selectedWorkspace,
    owner: props.user,
    workspaceId: props.selectedWorkspace.SK,
    environmentId: props?.selectedEnvironment?.SK,
  };
  const [ux, setUx] = useState("list");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const [pending, setPending] = useState(false);
  const [lookUpModal, setLookUpModal] = useState(false);
  const [segmentFields, setSegmentFields] = useState(null);
  const [selectedField, setSelectedField] = useState([{ field: null }]);
  const [selectedFieldMap, setSelectedFieldMap] = useState([]);
  const [selectedDefaultValue, setSelectedDefaultValue] = useState("");
  const [triggerSample, setTriggerSample] = useState("");
  const [triggerMap, setTriggerMap] = useState(false);
  const [showEnvironmentDropdown, setShowEnvironmentDropdown] = useState(false);
  const [trigger, setTrigger] = useState(null);
  const [next, setNext] = useState(null);
  const [sampleMap, setSampleMap] = useState({});
  const [sampleMessageInput, setSampleMessageInput] = useState(true);
  const [targets, setTargets] = useState(null);
  const [fieldMapGrid, setFieldMapGrid] = useState([]);
  const [eventTriggerGrid, setEventTriggerGrid] = useState([]);
  const [sampleFilter, setSampleFilter] = useState(true);
  const [definitions, setDefinitions] = useState([]);
  const [workflow, setWorkflow] = useState(placeholder);
  const [currentLookups, setCurrentLookups] = useState({});
  const [unchanged, setUnchanged] = useState(props.workflow);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showMessageIDModal, setShowMessageIDModal] = useState(false);
  const [messageEvent, setMessageEvent] = useState("");
  const [fhirMap, setFhirMap] = useState();
  const [fhirLoading, setFhirLoading] = useState(false);
  const [fhirSampleMap, setFHIRSampleMap] = useState({});
  const [showTemplatesModal, setShowTemplatesModal] = useState(false);

  useEffect(() => { 
    if (!definitions.length) { bootstrapDefinitions(); }
  }, [JSON.stringify(props.selectedEnvironment)]);

  useEffect(() => { 
    if (workflow.SK) { loadWorkflow(workflow); }
    if (workflow.fields && workflow.sampleMessage) { validatePayload(); }
  }, [workflow?.SK, workflow?.sampleMessage]);

  useEffect(() => { 
    if (workflow.trigger.type.substring(0, 4) == "MLLP") {  hydrateMappingGrids(); }
  }, [sampleFilter]);

  const bootstrapDefinitions = async () => {
    const PK = props.user.account.PK ? props.user.account.PK : '';
    const definitions = await post(`workflow/get-definitions/`);
    if (response.ok && definitions) {
      const defs : [] = Object.entries(definitions.definitions[0].definition);
      setDefinitions(defs);
    }
  };
  const hydrateMappingGrids = async () => {
    if (definitions.length > 0 && workflow.sampleMessage) {
      const newFieldMapGrid: any = [];
      const newTriggerMapGrid: any = [];
      let triggerSampleData: any = [];
      const sampleHL7 = new Hl7Standard(workflow.sampleMessage);
      sampleHL7.transform(async (err: any) => { if (err) { console.log(err); }});
      const segments = sampleHL7.getSegments();
      const sampleData: any[] = [];
      for (let i = 0; i < segments.length; i++) {
        const segment = Object.entries(segments[i].data);
        segment.forEach((entry) => {
          const [key, value] = entry;
          if (typeof value === 'object') {
            const subfieldEntries = Object.entries(value);
            subfieldEntries.forEach(([subfieldKey, subfieldValue]) => {
              let newSubfieldKey = subfieldKey;
              if (typeof subfieldValue === 'object') {
                const flattenedSubfieldData = flattenSampleData(subfieldValue, newSubfieldKey);
                sampleData.push(...flattenedSubfieldData);
              } else {
                const flattenedSubfieldData = flattenSampleDataNoAmpersand(value, newSubfieldKey);
                sampleData.push(...flattenedSubfieldData);
              }
            });
          } else sampleData.push([key, value]);
        });
      }
      const fields = Object.entries(workflow.fields);
      const triggerObject = workflow.trigger.custom ? workflow.trigger.custom : {};
      sampleData.map((entry: any) => {
        let specificationKey: any = null;
        let specificationValue: any = null;
        const [entryKey, entryValue] = entry;
        const specificationMap = definitions.filter((Map: any) => { if (Map[0] === entryKey) { return Map; }});
        if (specificationMap[0]) {
          specificationKey = specificationMap[0][0];
          specificationValue = specificationMap[0][1];
        }
        fields.map((field) => {
          const [fieldKey, fieldValue] = field;
          const duplicateFields = newFieldMapGrid.filter((row: any) => row[1].field === fieldKey);
          if (entryKey === fieldKey && fieldValue && duplicateFields.length === 0) {
            newFieldMapGrid.push([
              { definition: specificationValue ? specificationValue : 'CUSTOM' },
              { field: entryKey },
              { sample: entryValue ? entryValue : '' },
              { target: fieldValue }
            ]);
          }
        });
        for (let index = 0; index < Object.entries(triggerObject).length; index++) {
          const filter = Object.entries(triggerObject)[index];
          if (entryKey === filter[0] && filter[1] && props.selectedWorkspace.hash.location !== entryKey) {
            newTriggerMapGrid.push([
              { definition: specificationValue ? specificationValue : 'CUSTOM' },
              { field: entryKey },
              { sample: entryValue ? entryValue : '' },
              { filter: filter[1] }
            ]);
          }
        }
        const duplicateTriggerFields = newTriggerMapGrid.filter((row: any) => row[1].field === entryKey);
        const duplicateFields = newFieldMapGrid.filter((row: any) => row[1].field === entryKey);
        if (props.selectedWorkspace && props.selectedWorkspace.hash.location === entryKey) {
          triggerSampleData = entryValue ? entryValue : '';
        }
        if (duplicateTriggerFields.length < 1 && sampleFilter) {
          if (
            (!specificationValue && entryValue.length > 0 && props.selectedWorkspace.hash.location !== entryKey) ||
            (specificationValue && props.selectedWorkspace.hash.location !== entryKey)
          ) {
            newTriggerMapGrid.push([
              { definition: specificationValue ? specificationValue : 'CUSTOM' },
              { field: entryKey },
              { sample: entryValue ? entryValue : '' },
              { filter: '' }
            ]);
          }
        }
        if (duplicateFields.length < 1 && sampleFilter) {
          if ((!specificationValue && entryValue.length > 0) || (specificationValue)) {
            newFieldMapGrid.push([
              { definition: specificationValue ? specificationValue : 'CUSTOM' },
              { field: entryKey },
              { sample: entryValue ? entryValue : '' },
              { target: '' }
            ]);
          }
        }
      });
      const messageEventFromMessage = sampleHL7.get('MSH.9.2');
      let mappedEvent;
      if (workflow.next.type == 'S3 FHIR R4' || workflow.next.type == 'HTTPS FHIR R4') { 
        mappedEvent = hl7v2EventTofhirr4MethodMap.filter((event) => event.hl7v2 === messageEventFromMessage);
        mappedEvent[0] ? updateTriggerMethod(mappedEvent[0]) : null;
      }
      setTriggerSample(triggerSampleData);
      setEventTriggerGrid(newTriggerMapGrid);
      setFieldMapGrid(newFieldMapGrid);
    }
  };
  const updateFieldMap = async (event: any) => {
    event.preventDefault();
    if (workflow.trigger.type.substring(0, 4) == "MLLP") {
      if (event.target.value.length < 1) {
        removeFieldMapRow(workflow.fields[event.target.id]);
      } else {
        workflow.fields[event.target.id] = event.target.value;   
      }
    }
    if (workflow.trigger.type.substring(0, 4) == "HTTP") {
      if (event.target.length < 1) {
        removeFieldMapRow(workflow.fields[event.key]);
      } else {
        workflow.fields[event.key] = event.target;
      }
    }
    setWorkflow(workflow);
    hydrateMappingGrids();
  };
  const canCreate = () => {
    const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter(
      (account: any) => {
        if (account.PK && account.permissions.workflows.create) return account;
      }
    );
    const isWorkspaceOwner =
      props.selectedWorkspace.owner.email === props.user.account.email;
    if (
      props.admin === true ||
      hasUpdateWorkflowInSelectedWorkspace.length ||
      isWorkspaceOwner
    ) {
      return true;
    }
    return false;
  };
  const canUpdate = () => {
    const hasUpdateWorkflowInSelectedWorkspace = props.selectedWorkspace.accounts.filter(
      (account: any) => {
        if (account.PK && account.permissions.workflows.update) return account;
      }
    );
    const isWorkspaceOwner =
      props.selectedWorkspace.owner.email === props.user.account.email;
    if (
      props.admin === true ||
      hasUpdateWorkflowInSelectedWorkspace.length ||
      isWorkspaceOwner
    ) {
      return true;
    }
    return false;
  };
  const loadWorkflow = async (flow: any) => {
    setWorkflow(flow);
    setUnchanged(flow);
    hydrateMappingGrids();
    setNext(flow.next);
    setTrigger(flow.trigger);
    setUx("adapters");
    setCurrentLookups(workflow.lookups);
    if (flow.sampleMessage && flow.fields)
    { validatePayload();} 
  };
  const saveWorkflow = async () => {
    setPending(true);
    if (triggerSample != props.selectedWorkspace.hash.value) {
      setShowMessageIDModal(true);
    }
    saveFlow();
    setPending(false);
  };
  const saveTemplate = async () => {
    const { selectedEnvironment, selectedWorkspace } = props;
    if (workflow.PK.length) {
      if (
        selectedWorkspace.SK != workflow.workspaceId &&
        selectedEnvironment.SK == workflow.environmentId
      ) {
        setPending(false);
        setError("SaveInAnotherAccountException");
      }
      if (
        selectedWorkspace.SK == workflow.workspaceId &&
        selectedEnvironment.SK != workflow.environmentId
      ) {
        if (canUpdate()) {
          if (!workflow.SK) workflow.SK = 'WFTEMPLATEID#' + uuid();
          const template = {
            name: workflow.flowName,
            fields: workflow.fields,
            next: workflow.next,
            trigger: workflow.trigger,
            lookups: workflow.lookups,
            Entity: 'WFTEMPLATE'
          };

          const body = { template, selectedEnvironment };
          const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
          const newTemplate = await post(`workflow/save-template/${PK}`, body);
          setPending(false);
        } else {
          setPending(false);
          setError("UserPermissionsException");
        }
      }
    }
    if (!workflow.flowName) {
      workflow.flowName = "My Template";
    }
    if ((workflow.PK && canUpdate()) || (!workflow.PK && canCreate())) {
      if (!workflow.SK) workflow.SK = 'WFTEMPLATEID#' + uuid();
      const template = {
        name: workflow.flowName,
        fields: workflow.fields,
        next: workflow.next,
        trigger: workflow.trigger,
        lookups: workflow.lookups,
        Entity: 'WFTEMPLATE'
      };

      const body = { template, selectedEnvironment };
      const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
      const newTemplate = await post(`workflow/save-template/${PK}`, body);
      if (response.ok && newTemplate) {
        console.dir(newTemplate);
      }
    }
  };

  const saveFlow = async () => {
    const { selectedEnvironment, selectedWorkspace } = props;
    if (workflow.PK.length) {
      if (
        selectedWorkspace.SK != workflow.workspaceId &&
        selectedEnvironment.SK == workflow.environmentId
      ) {
        setPending(false);
        setError("SaveInAnotherAccountException");
      }
    }
    if (!workflow.flowName) {
      workflow.flowName = "My Workflow";
    }
    if (selectedEnvironment.name.substring(0, 3) != "Dev") {
      workflow.trigger.custom[selectedWorkspace.hash.location] =
        selectedWorkspace.hash.value;
    } else {
      delete workflow.trigger.custom[selectedWorkspace.hash.location];
    }
    if ((workflow.PK && canUpdate()) || (!workflow.PK && canCreate())) {
      if (!workflow.SK) workflow.SK = 'WORKFLOWID#' + uuid();
      const body = { workflow, environment: selectedEnvironment, workspace: selectedWorkspace };
      const PK = workflow.owner.attributes ? workflow.owner.attributes.id : workflow.owner.external_id;
      workflow.PK = PK;
      const newFlow = await post(`workflow/save-workflow/${PK}`, body);
      if (response.ok && newFlow) {
        loadWorkflow(newFlow.wf);
        setUnchanged(newFlow.wf);
        setPending(false);
        setLookUpModal(false);
      }
    }
  };
  const isStarted = () => {
    if (workflow?.flowName != placeholder.flowName || workflow?.sampleMessage != placeholder.sampleMessage) {
      return true;
    }
    return false;
  };
  const handleFlowNameChange = (event: any) => {
    const updated = { ...workflow, flowName: event.target.value };
    setWorkflow(updated);
  };
  const handleSampleMessageChange = (event: any) => {
    workflow.sampleMessage = event.target.value;
    const updated = { ...workflow, sampleMessage: event.target.value };
    setWorkflow(updated);
    if (event.target.id == "sample-message-hl7v2") {
      hydrateMappingGrids();
    } 
  };
  const handleNextS3BucketName = (event: any) => {
    const updated = {
      ...workflow,
      next: { ...workflow.next, bucket: event.target.value },
    };
    setWorkflow(updated);
  }
  const handleNextS3Key = (event: any) => {
    const updated = {
      ...workflow,
      next: { ...workflow.next, key: event.target.value },
    };
    setWorkflow(updated);
  }
  const createS3Bucket = async () => {
    const bucketName = workflow.next.bucket;
    const { selectedEnvironment, selectedWorkspace } = props;
    const body = {
      environment: selectedEnvironment,
      workspace: selectedWorkspace,
      account: props.user.account,
      bucketName,
    };
    const bucket = await post(`environment/create-s3-bucket/${props.user.attributes.id}`, body);
    if (bucket && response.ok) {
      console.dir(bucket);
      setPending(false);
    }
  }
  const handleNextUrl = (event: any) => {
    const updated = {
      ...workflow,
      next: { ...workflow.next, url: event.target.value },
    };
    setWorkflow(updated);
  };
  const handleNextIP = (event: any) => {
    const updated = {
      ...workflow,
      next: { ...workflow.next, ip: event.target.value },
    };
    setWorkflow(updated);
  };
  const handleNextPort = (event: any) => {
    const updated = {
      ...workflow,
      next: { ...workflow.next, port: event.target.value },
    };
    setWorkflow(updated);
  };
  const validatePayload = async () => {
    if (workflow.trigger.type.substring(0, 4) == "MLLP" && workflow.sampleMessage) {
      const sample = new Hl7Standard(workflow.sampleMessage);
      sample.transform(async (err: any) => {
        if (err) { console.log(err); }
      });
      if (workflow.lookups.length > 0) {
        const transformed = await transformPayload(sample, workflow.lookups);
        const hl7 = new Hl7Standard(transformed);
        hl7.transform((err: any) => {
          if (err) throw err;
        });
        const payload: any = await buildPayload(workflow.fields, hl7);
        setSampleMap(payload);
      } else {
        const payload: any = await buildPayload(workflow.fields, sample);
        setSampleMap(payload);
      }
    }
  };
  const updateFieldMapKey = (event: any) => {
    for (let index = 0; index < workflow.lookups.length; index++) {
      const lookup: any = workflow.lookups[index];
      // We have lookups for this field
      if (lookup.field && lookup.field == selectedField[1].field) {
        const maps = lookup.map;
        for (let index2 = 0; index2 < maps.length; index2++) {
          const map = maps[index2];
          const id = event.target.id.split("-")[2]+1;
          if (map.id == id) {
            map.key = event.target.value;
          }
        }
      }
    }
    setWorkflow(workflow);
    validatePayload();
  };
  const updateFieldMapValue = (event: any) => {
    for (let index = 0; index < workflow.lookups.length; index++) {
      const lookup: any = workflow.lookups[index];
      // We have lookups for this field
      if (lookup.field == selectedField[1].field) {
        const maps = lookup.map;
        for (let index2 = 0; index2 < maps.length; index2++) {
          const map = maps[index2];
          const id = event.target.id.split("-")[2]+1;
          if (map.id == id) {
            if (event.target.value.length > 0) {
              map.value = event.target.value;
            } else {
              removeRow(index2);
            }
            
          }
        }
      }
    }
    setWorkflow(workflow);
    validatePayload();
  };
  const updateWorkflowEnvironment = async (selectedEnvironment: any, selectedWorkspace: any, workflow: any) => {
    setPending(true);
    workflow.PK = workflow.owner.attributes.id;
    const body = {
      previousEnvironment: workflow.environment,
      selectedEnvironment,
      selectedWorkspace,
      workflow,
    };
    await post(`workflow/move-workflow/${props.user.attributes.id}`, body);
    if (response.ok) {
      setLookUpModal(false);
      setPending(false);
    }
  };
  const handleLookupDefaultValueChange = (event: any) => {
    event.preventDefault();
    for (let index = 0; index < workflow.lookups.length; index++) {
      const lookup: any = workflow.lookups[index];
      if (lookup.field == selectedField[1].field) {
        lookup.default = event.target.value;
      }
    }
    setWorkflow(workflow);
    setSelectedDefaultValue(event.target.value);
  };
  const toggleLookUpModal = (fieldMap: any) => {
    if (fieldMap) {
      let found = false;
      const { lookups } = workflow;
      if (lookups?.length > 0) {
        for (let a = 0; a < lookups.length; a++) {
          const lookup: any = lookups[a];
          if (lookup.field == fieldMap[1].field) {
            found = true;
            if (!lookup.default) {
              setWorkflow(workflow);
            }
            setSelectedDefaultValue(lookup.default);
            setSelectedField(fieldMap);
            setSelectedFieldMap(lookup);
          }
        }
        if (found == false) {
          const lookup = {
            field: fieldMap[1].field,
            map: [{ id: 1, key: "", value: "" }],
            default: "",
          };
          workflow.lookups.push(lookup);
          for (let a = 0; a < workflow.lookups.length; a++) {
            const lookup: any = workflow.lookups[a];
            if (lookup.field == fieldMap[1].field) {
              found = true;
              if (!lookup.default) {
                setWorkflow(workflow);
              }
              setSelectedDefaultValue(lookup.default);
              setSelectedField(fieldMap);
              setSelectedFieldMap(lookup);
            }
          }
        }
        setLookUpModal(true);
      } else {
        workflow.lookups = [{
          field: fieldMap[1].field,
          map: [{ id: 1, key: "", value: "" }],
          default: "",
        }];
        const selectedFieldMap: any = workflow.lookups[0];
        setSelectedDefaultValue("");
        setSelectedField(fieldMap);
        setSelectedFieldMap(selectedFieldMap);
        setLookUpModal(true);
        setWorkflow(workflow);
      }
    } else {
      setLookUpModal(false);
    }
  };
  const addRowToLookupsHandler = () => {
    workflow.lookups.map((lookup: any) => {
      if (lookup.field == selectedField[1].field) {
        lookup.map.push({ id: lookup.map.length + 1, key: "", value: "" });
      }
    });
    setWorkflow(workflow);
    setCurrentLookups(workflow.lookups);
    toggleLookUpModal(selectedField);
  };
  const removeRow = (id: any) => {
    workflow.lookups.map((lookup: any) => {
      if (lookup.field == selectedField[1].field) {
        lookup.map.splice(lookup.map.indexOf(lookup.map[id]), 1);
      }
    });
    setWorkflow(workflow);
  };
  const removeFieldMapRow = (rowArray: any) => {
    if (rowArray[1]?.field) {
      const row = {
        definition: rowArray[0].definition,
        field: rowArray[1]?.field,
        sample: rowArray[2].sample,
        target: rowArray[3].target,
      };
      delete workflow.fields[row.field];
    }
    setWorkflow(workflow);
    hydrateMappingGrids();
  };
  const updateTrigger = (event: any) => {
    if (event.target.value.length > 0) {
      workflow.trigger.custom[event.target.id] = event.target.value;
      const triggerArray = Object.entries(workflow.trigger.custom);
      workflow.trigger.key = triggerArray
        .map((row) => {
          return row[1];
        })
        .join(".");
      workflow.trigger.formula = triggerArray
        .map((row) => {
          return row[0];
        })
        .join("-");
      setWorkflow(workflow);
    } else {
      delete workflow.trigger.custom[event.target.id];
      const triggerArray = Object.entries(workflow.trigger.custom);
      workflow.trigger.key = triggerArray
        .map((row) => {
          return row[1];
        })
        .join(".");
      workflow.trigger.formula = triggerArray
        .map((row) => {
          return row[0];
        })
        .join("-");
      setWorkflow(workflow);
    }
  };
  const removeTriggerMapRow = (rowArray: any) => {
    const row = {
      definition: rowArray[0].definition,
      field: rowArray[1].field,
      sample: rowArray[2].sample,
      target: rowArray[3].target,
    };
    delete workflow.trigger.custom[row.field];
    setWorkflow(workflow);
    hydrateMappingGrids();
  };
  const setCsvFileHandler = (file: any) => {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csv: any = reader.result;
      const lines = csv.split("\n");
      const headers = lines[0].split(",");
      const data = [];
      for (let i = 0; i < lines.length; i++) {
        let obj = {};
        const currentline = lines[i].split(",");
        for (let j = 0; j < headers.length; j++) {
          obj = {
            id: i,
            key: currentline[0],
            value: currentline[1].replace(/[\n\r]+/g, ""),
          };
        }
        data.push(obj);
      }
      if (workflow.lookups.length > 0) {
        for (let index = 0; index < workflow.lookups.length; index++) {
          const lookup: any = workflow.lookups[index];
          if (lookup.field == selectedField[1].field) {
            lookup.map = data;
          }
        }
      }
      setWorkflow(workflow);
    };
    reader.readAsText(file);
  };
  const clearToggle = (field: any) => {
    if (workflow.lookups.length > 0) {
      for (let index = 0; index < workflow.lookups.length; index++) {
        if (workflow.lookups[index].field === field) {
          workflow.lookups[index] = {
            field,
            map: [{ id: 1, key: "", value: "" }],
            default: "",
          };
        }
      }
    }
    setWorkflow(workflow);
    setLookUpModal(false);
  };
  const newWorkflowClickHandler = () => {
    setUx("adapters");
  };
  const backToListClickHandler = () => {
    if (isStarted()) setShowConfirmModal(true); else setUx("list");
  };
  const eventTriggerClickHandler = () => {
    setUx("e-layer");
  };
  const adapterClickHandler = () => {
    setUx("adapters");
  };
  const mapClickHandler = async () => {
    await hydrateMappingGrids();
    setUx("t-layer");
  };
  const loadClickHandler = async () => {
    if (workflow.next.type == 'HTTPS JSON') await validatePayload();
    setUx("l-layer");
  };
  const enableSampleFilter = async () => {
    setSampleFilter(!sampleFilter);
    hydrateMappingGrids();
  };
  const updateEventTrigger = (event: any) => {
    const trigger = event;
    workflow.trigger = { ...workflow.trigger, ...trigger };
    setWorkflow(workflow);
    setTrigger(trigger);
  };
  const updateActionTrigger = (event: any) => {
    const next = event;
    workflow.next = { ...workflow.next, ...next };
    setWorkflow(workflow);
    setNext(next);
  };
  const fetchHL7v2Map = async () => {
    const body = { selectedAction: workflow.next.action };
    const segmentRequest = await post(`workflow/list-segments/json-hl7v2`, body);
    return segmentRequest.segments;
  };
  const fetchFHIRR4Map = async () => {
    setFhirLoading(true);
    const sampleMessageLines = workflow.sampleMessage.split(/\r?\n/);
    let fhirMapsCombined: any = {};
    for (let i = 0; i < sampleMessageLines.length; i++) {
      if (sampleMessageLines[i].length <= 1) continue; 
      const body = { sampleMessageSegment: sampleMessageLines[i] };
      try {
        const fhirMapRequest = await post(`workflow/hl7v2-to-fhir/`, body);
        const reqObj: any = Object.entries(fhirMapRequest);
        if (fhirMapRequest && reqObj.length > 0) {
          Object.assign(fhirMapsCombined, fhirMapRequest);
        }
      } catch (error) {
        console.error(`Error posting line ${i}:`, error);
      }
    }
    setFhirLoading(false);
    if (fhirMapsCombined) {
      setFhirMap(fhirMapsCombined);
      workflow.fields = fhirMapsCombined;
      setWorkflow(workflow);
      hydrateMappingGrids();
      const payload = createFHIRBundle(fhirMapsCombined, workflow.sampleMessage);
      setFHIRSampleMap(payload);
    }
  };
  const getHL7SegmentFields = async (segments: any) => {
    const body = { segments };
    const segmentRequest = await post(
      `workflow/list-sample-segment-fields/${props.user.attributes.id}`,
      body
    );
    return segmentRequest.segmentRequest;
  };
  const updateHL7ActionTrigger = async (event: any) => {
    const next = event;
    workflow.next.action = next.label;
    const segmentLists = await fetchHL7v2Map();
    const segmentFields = await getHL7SegmentFields(segmentLists);
    setSegmentFields(segmentFields);
    parseJSONSampleIntoGrid();
  };
  const parseJSONSampleIntoGrid = async () => {
    const fieldMapGrid: any = [];
    const segFields =
      segmentFields || (await getHL7SegmentFields(workflow.next.action));
    segFields.map((row: any) => {
      if (Object.entries(workflow.fields).length > 0) {
        Object.entries(workflow.fields).map((field: any) => {
          const [fieldKey, fieldValue] = field;
          if (row[0] === fieldKey && fieldValue) {
            fieldMapGrid.push([
              { definition: row[1] ? row[1] : "CUSTOM" },
              { field: row[0] },
              { sample: fieldValue.value },
              { target: fieldValue.key ? fieldValue.key : "" },
            ]);
          }
        });
      }
      const duplicateFields = fieldMapGrid.filter((gridRow: any) => {
        if (gridRow[1].field == row[0]) return gridRow;
      });
      if (duplicateFields.length === 0 && sampleFilter) {
        fieldMapGrid.push([
          { definition: row[1] ? row[1] : "CUSTOM" },
          { field: row[0] },
          { sample: "" },
          { target: "" },
        ]);
      }
    });
    setWorkflow(workflow);
    setFieldMapGrid(fieldMapGrid);
  };
  const parseJSONSampleMessage = (message: any) => {
    const sample = Object.entries(message);
    const targets: any = [];
    sample.map((sampleRow: any) => {
      const isPatient = sampleRow[0] == "patient";
      if (isPatient) {
        const patient = Object.entries(sampleRow[1]);
        patient.map((patientRow: any) => {
          if (typeof patientRow[1] === "string") {
            targets.push({
              key: patientRow[0],
              value: patientRow[1],
              label: patientRow[0],
            });
          }
          if (
            typeof patientRow[1] === "object" &&
            typeof patientRow[1][0] !== "object"
          ) {
            targets.push({
              key: patientRow[0],
              value: patientRow[1][0],
              label: patientRow[0],
            });
          }
          if (
            typeof patientRow[1] === "object" &&
            typeof patientRow[1][0] === "object"
          ) {
            const position = Object.entries(patientRow[1][0])[0][1];
            targets.push({
              key: patientRow[0],
              value: Object.entries(patientRow[1][0])[1][1],
              label: patientRow[0],
            });
          }
        });
      }
    });
    setTargets(targets);
  };
  const setCopiedHandler = () => {
    setCopied(true);
  };
  const clearError = () => {
    setError("");
  };
  const showEnvironmentDropdownHandler = () => {
    setShowEnvironmentDropdown(!showEnvironmentDropdown);
  };
  const showSampleMessageInput = () => {
    setSampleMessageInput(!sampleMessageInput);
    setTriggerMap(!triggerMap);
  };
  const updateTriggerMethod = async (event: any) => { 
    const method = event.method;
    workflow.next.method = method;
    setWorkflow(workflow);
  };
  const onChangeHost = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, host: event.target.value },
    };
    setWorkflow(updated);
  };
  const onChangeUsername = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, username: event.target.value },
    };
    setWorkflow(updated);
  }
  const onChangePort = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, port: event.target.value }
    };
    setWorkflow(updated);
  };
  const onChangePath = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, path: event.target.value }
    };
    setWorkflow(updated);
  }
  const onChangeCadence = (option: any) => {
    const updated = {
      ...workflow,
      cadence: option
    };
    setWorkflow(updated);
  }
  const onChangeCert = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, cert: event.target.value }
    };
    setWorkflow(updated);
  };
  const onChangePrivateKey = (event: any) => {
    const updated = {
      ...workflow,
      trigger: { ...workflow.trigger, privateKey: event.target.value }
    };
    setWorkflow(updated);
  };
  const showTemplates = () => {
    setShowTemplatesModal(!showTemplatesModal);
  }

  if (!props.selectedWorkspace || !props.selectedEnvironment) {
    return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <h1 className="display-4">No Workspace Selected</h1>
                <p className="lead">Please select a workspace from the dropdown above.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
  if (ux === "list") {
    return (
      <WorkflowsGrid
        user={props.user}
        account={props.account}
        accounts={props.accounts}
        environments={props.environments}
        setShowEnvironmentDropdown={showEnvironmentDropdownHandler}
        selectedEnvironment={props.selectedEnvironment}
        selectedWorkspace={props.selectedWorkspace}
        setSelectedEnvironment={props.setSelectedEnvironment}
        newWorkflowClickHandler={newWorkflowClickHandler}
        loadWorkflow={loadWorkflow}
        logout={props.logout}
        showEnvironmentDropdownHandler={showEnvironmentDropdownHandler}
        showEnvironmentDropdown={showEnvironmentDropdown}
        admin={props.admin}
        updateBillingCustomer={props.updateBillingCustomer}
      />
    );
  } else if (ux != "list") {
    return (<>
      { showConfirmModal && 
        <ConfirmModal
          isOpen={showConfirmModal}
          message="You have unsaved changes. Are you sure you want to go back?"
          title="Go Back?"
          onConfirm={() => {setWorkflow(placeholder); setUx("list"); }}
          onClose={() => setShowConfirmModal(false)}
        />
      }
      { showMessageIDModal && 
        <ConfirmModal
          isOpen={showMessageIDModal}
          message="Your sample message doesn't contain your workspace's unique message identifier. Are you sure you want to save?"
          title="Unique Message Identifier"
          onConfirm={() => {saveWorkflow(); setShowMessageIDModal(false); }}
          onClose={() => setShowMessageIDModal(false)}
        />
      }
      { showTemplatesModal &&
        <TemplatesModal
          isOpen={showTemplatesModal}
          templates={props.templates}
          applyTemplate={saveTemplate}
          closeModal={() => setShowTemplatesModal(false)}
        />
      }
      <SubNav
        isStarted={isStarted}  
        workflow={workflow}
        backToListClickHandler={backToListClickHandler}
        saveWorkflow={saveWorkflow}
        pending={pending}
        environments={props.environments}
        setShowEnvironmentDropdown={showEnvironmentDropdownHandler}
        showEnvironmentDropdownHandler={showEnvironmentDropdownHandler}
        showEnvironmentDropdown={showEnvironmentDropdown}
        user={props.user}
        accounts={props.accounts}
        selectedEnvironment={props.selectedEnvironment}
        account={props.account}
        selectedWorkspace={props.selectedWorkspace}
        setSelectedEnvironment={props.setSelectedEnvironment}
        loadClickHandler={loadClickHandler}
        mapClickHandler={mapClickHandler}
        adapterClickHandler={adapterClickHandler}
        eventTriggerClickHandler={eventTriggerClickHandler}
        handleFlowNameChange={handleFlowNameChange}
        placeholder={placeholder}
        loading={loading}
        fhirLoading={fhirLoading}
        ux={ux}
        saveTemplate={saveTemplate}
        
      />
      { ux === "adapters" && 
        <AdaptersMain
          workflow={workflow}
          setWorkflow={setWorkflow}
          placeholder={placeholder}
          selectedEnvironment={props.selectedEnvironment}
          adapterClickHandler={adapterClickHandler}
          updateEventTrigger={updateEventTrigger}
          sampleMessageInput={sampleMessageInput}
          handleSampleMessageChange={handleSampleMessageChange}
          selectedWorkspace={props.selectedWorkspace}
          updateActionTrigger={updateActionTrigger}
          updateHL7ActionTrigger={updateHL7ActionTrigger}
          parseJSONSampleMessage={parseJSONSampleMessage}
          error={error}
          handleFlowNameChange={handleFlowNameChange}
          clearError={clearError}
          showTemplates={showTemplates}
        />
      }
      { ux === "e-layer" && 
        <ELayerMain
          workflow={workflow}
          clearError={clearError}
          environments={props.environments}
          error={error}
          triggerMap={triggerMap}
          enableSampleFilter={enableSampleFilter}
          sampleFilter={sampleFilter}
          messageEvent={messageEvent}
          hl7v2EventTofhirr4MethodMap={hl7v2EventTofhirr4MethodMap}
          updateTriggerMethod={updateTriggerMethod}
          showSampleMessageInput={showSampleMessageInput}
          selectedEnvironment={props.selectedEnvironment}
          selectedWorkspace={props.selectedWorkspace}
          triggerSample={triggerSample}
          eventTriggerGrid={eventTriggerGrid}
          trigger={trigger}
          updateEventTrigger={updateEventTrigger}
          showSampleTriggerGrid={showSampleMessageInput}
          updateTrigger={updateTrigger}
          loading={loading}
          removeTriggerMapRow={removeTriggerMapRow}
          onChangeHost={onChangeHost}
          onChangeUsername={onChangeUsername}
          onChangePort={onChangePort}
          onChangePath={onChangePath}
          onChangeCadence={onChangeCadence}
          onChangeCert={onChangeCert}
          onChangePrivateKey={onChangePrivateKey}
        />
      }
      { ux === "t-layer" && 
        <TLayerMain
          error={error}
          clearError={clearError}
          workflow={workflow}
          loading={loading}
          sampleFilter={sampleFilter}
          enableSampleFilter={enableSampleFilter}
          selectedWorkspace={props.selectedWorkspace}
          fieldMapGrid={fieldMapGrid}
          fhirMap={fhirMap}
          removeFieldMapRow={removeFieldMapRow}
          updateFieldMap={updateFieldMap}
          toggleLookUpModal={toggleLookUpModal}
          hydrateMappingGrids={hydrateMappingGrids}
          validatePayload={validatePayload}
          targets={targets}
          fetchFHIRR4Map={fetchFHIRR4Map}
          fhirLoading={fhirLoading}
        />
      }
      { ux === "t-layer" && 
        <TargetValueModal
          workflow={workflow}
          toggleLookUpModal={toggleLookUpModal}
          selectedField={selectedField}
          handleLookupDefaultValueChange={handleLookupDefaultValueChange}
          selectedFieldMap={selectedFieldMap}
          addRowToLookupsHandler={addRowToLookupsHandler}
          setCsvFile={setCsvFileHandler}
          selectedDefaultValue={selectedDefaultValue}
          selectedWorkspace={props.selectedWorkspace}
          removeRow={removeRow}
          clearToggle={clearToggle}
          updateFieldMapKey={updateFieldMapKey}
          updateFieldMapValue={updateFieldMapValue}
          open={lookUpModal}
          validatePayload={validatePayload}
          saveWorkflow={saveWorkflow}
          currentLookups={currentLookups}
        />
      }
      { ux === "l-layer" && 
        <LLayerMain
          error={error}
          clearError={clearError}
          updateActionTrigger={updateActionTrigger}
          workflow={workflow}
          next={next}
          handleNextUrl={handleNextUrl}
          sampleMap={sampleMap}
          handleNextIP={handleNextIP}
          handleNextPort={handleNextPort}
          selectedEnvironment={props.selectedEnvironment}
          selectedWorkspace={props.selectedWorkspace}
          setCopiedHandler={setCopiedHandler}
          copied={copied}
          createS3Bucket={createS3Bucket}
          handleNextS3BucketName={handleNextS3BucketName}
          handleNextS3Key={handleNextS3Key}
          fhirSampleMap={fhirSampleMap}
        />
      }
  </>);
  } else {
    return (
      <div className="items-center animate-pulse py-48 sm:py-24 md:py-32 lg:py-48">
        <img className="h-24 mx-auto w-auto" src={logo} alt="Logo" />
        <h2 className="mt-0 text-center text-2xl font-bold text-gray-200">
          Retrohook
          <span className="inline align-middle text-xs tracking-tight text-cyan-300 pl-1"></span>
        </h2>
      </div>
    );
  }
}
